import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import {Button} from '@finpay-development/shared-components';
import Dialog from '@mui/material/Dialog';
import React, {Dispatch, SetStateAction} from 'react';
import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

export const DocumentDeleteModal = ({

                                      selectedDocumentId,
                                      setIsOpen,
                                      deleteOnClick,
                                    }: {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  selectedDocumentId: number
  deleteOnClick: (patientDocumentId: number) => void
}) => {

  return (
      <Dialog
          scroll="body"
          className="modal client-modal"
          open={true}
          fullWidth={true}
          maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid item xs={12}>
            <Typography variant="h6"> Delete File</Typography>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid item xs={12}>
              <Typography> Are you sure you want to delete this file
                ?</Typography>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
              onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button
              onClick={() => deleteOnClick(selectedDocumentId)}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
  );

};